import { createSlice } from "@reduxjs/toolkit";
export const initialState = {
  instance: null,
};
const queueSlice = createSlice({
  name: "queue",
  initialState,
  reducers: {
    setQueue: (state, action) => {
      state.queue = action.payload;
    }
  },
});
export const { setQueue } = queueSlice.actions;
export default queueSlice.reducer;